import { Component, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import {
    Config,
    Nav,
    Platform,
    AlertController,
    App,
    MenuController,
    ToastController,
    Events,
    Content
} from 'ionic-angular';
import { AuthProvider } from '../providers/auth/auth';
import { FirstRunPage } from '../pages';
//import { Device } from '@ionic-native/device';
import { environment } from '../environments/environment';
import { Api } from '../providers';
import OneSignal from 'onesignal-cordova-plugin';
import { Badge } from '@ionic-native/badge';
import { CallNumber } from '@ionic-native/call-number';
import { ProductOption } from '../bean/shop/product_option';
import { LogProvider } from '../providers/log/log';
import { CacheService } from "ionic-cache";
import { Siteinfo } from '../bean/siteinfo';
import { Storage } from '@ionic/storage';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Network } from "@ionic-native/network";

@Component({
    templateUrl: 'app.html',
})
export class MyApp {
    rootPage = FirstRunPage;

    @ViewChild(Nav) nav: Nav;
    @ViewChild(Content) content: Content;
    header: any = {};
    body: any = {};
    footer: any = {};
    menus: any = [];
    avatar: string = 'assets/imgs/logo.jpg';
    siteName: string = 'ANH THƯ TRAVEL';
    extraInfo: string;
    loginPage: string = 'LoginPage';
    signUpPage: string = 'SignupPage';
    is_logined: boolean = false;
    filterBar: ProductOption[] = [];
    siteInfo: Siteinfo;

    constructor(
        private translate: TranslateService,
        public platform: Platform,
        private config: Config,
        private statusBar: StatusBar,
        private splashScreen: SplashScreen,
        public authService: AuthProvider,
        //private device: Device,
        private storage: Storage,
        public alertCtrl: AlertController,
        public app: App,
        public menuCtrl: MenuController,
        public toastCtrl: ToastController,
        private api: Api,
        // private oneSignal: OneSignal,
        public badge: Badge,
        public network: Network,
        public toast: ToastController,
        public events: Events,
        private callNumber: CallNumber,
        public cache: CacheService,
        public logger: LogProvider,
        public deeplinks: Deeplinks
    ) {
        this.siteInfo = new Siteinfo({});
        //cache.setDefaultTTL(24 * 60 * 60); //set default cache TTL for 1 day
        platform.ready().then((readySource) => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            //this.statusBar.styleBlackTranslucent();

            //this.statusBar.overlaysWebView(false);
            //this.statusBar.hide();

            if (this.platform.is('cordova')) {
                //this.statusBar.backgroundColorByHexString("#FFFFFF");
                this.statusBar.backgroundColorByHexString('#00aeef');
                if (this.platform.is('android')) {
                    this.statusBar.styleLightContent();
                } else if (this.platform.is('ios')) {
                    //this.statusBar.styleLightContent();
                    this.statusBar.overlaysWebView(false);

                    this.statusBar.styleLightContent();


                }

                this.splashScreen.hide();
            }
            this.authService.checkToken().then((result: string) => {
                if (result === 'invalid') {
                    this.authService.renewToken().subscribe(res => {
                        this.getUserInfo();
                    });
                } else if (result === 'valid') {
                    this.getUserInfo();
                }

            });

            //console.log('Device UUID is: ' + this.device.uuid);
            this.getSiteinfo().subscribe((data: any) => {
                if (data['err_code'] === '') {
                    this.storage.set('SITE_INFO', data['data']);
                    this.siteInfo = new Siteinfo(data['data']);
                    this.siteName = this.siteInfo.sitename;
                }
            });
            this.getMenu().subscribe((data: any) => {
                if (data['err_code'] === '') {
                    //this.content = new Content(data['data']);
                    if ('header' in data['data']) {
                        this.header = data['data']['header'];
                    }
                    if ('body' in data['data']) {
                        this.body = data['data']['body'];
                    }
                    if ('footer' in data['data']) {
                        this.footer = data['data']['footer'];
                    }
                    if ('menus' in data['data']) {
                        this.menus = data['data']['menus'];

                    }
                }
            });
            if (this.platform.is('cordova')) {
                this.notification();
                this.checkNetwork();
                this.checkBadge();
            }
            this.initEvent();


            this.deeplinks.routeWithNavController(this.nav, {
                '/': {},
                '/:page/:id': {}
            }).subscribe((match) => {
                this.processDeeplink(match);
            }, (nomatch) => {

            });


        });
        this.fixBackButton();
        this.initTranslate();


        //this.imageLoaderConfig.setConcurrency(10);
        //this.imageLoaderConfig.enableDebugMode();
        //this.imageLoader.clearCache();
    }

    getUserInfo() {
        this.authService.authenticationState.subscribe(state => {
            if (state) {
                let info = this.authService.getUserInfo();
                this.siteName = 'Xin chào ' + info.name;
                this.extraInfo = info.level;
                this.extraInfo = info.group == 10 ? 'Loại: Nhân viên kho' : 'Loại: Khách hàng';
                this.is_logined = true;
            } else {
                this.siteName = this.siteInfo.sitename ? this.siteInfo.sitename : this.siteName;
                this.extraInfo = '';
            }
        });
    }

    private _resetValue() {
        this.siteName = this.siteInfo.sitename;
        this.extraInfo = '';
        this.is_logined = false;
    }

    phonetosite(number: string) {
        number = number.split('.').join('');
        number = number.split(' ').join('');
        // this.callNumber.callNumber(number, true)
        //     .then(res => console.log('Launched dialer!', res))
        //     .catch(err => console.log('Error launching dialer', err));
    }

    initEvent() {
        this.events.subscribe('user:login', (user, time) => {
            let info = this.authService.getUserInfo();
            this.siteName = 'Xin chào ' + info.name;
            this.extraInfo = info.level;
            this.is_logined = true;
        });

        this.events.subscribe('user:logout', (time) => {
            this._resetValue();
        });
        this.events.subscribe('product:filter', (list: ProductOption[]) => {
            this.filterBar = list;
        });

    }

    checkNetwork() {
        this.network.onDisconnect().subscribe(() => {
            this.events.publish('network:status', this.network.type);


        });

        this.network.onConnect().subscribe(() => {
            this.events.publish('network:status', this.network.type);
        });
    }

    notification() {
        const storage = this.storage;
        const events = this.events;
        // Remove this method to stop OneSignal Debugging
        OneSignal.setLogLevel(6, 0);

        // NOTE: Update the setAppId value below with your OneSignal AppId.
        OneSignal.setAppId(environment.onesignalId);
        OneSignal.setNotificationOpenedHandler(function (jsonData) {
            console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
        });

        // Prompts the user for notification permissions.
        //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
        OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
            console.log("User accepted notifications: " + accepted);
        });



    }

    checkBadge() {
        this.badge.isSupported().then(result => {
            if (result) {
                this.badge.hasPermission().then(permission => {
                    if (!permission) {
                        this.badge.requestPermission().then(isPermission => { });
                    }
                })
            }
        });
    }

    getMenu() {
        return this.api.get(environment.config, { type: 'slide_menu', showLoading: false });
    }

    getSiteinfo() {
        return this.api.get(environment.config, { type: 'site_info', showLoading: false });
    }

    initTranslate() {
        // Set the default language for translation strings, and the current language.
        this.translate.setDefaultLang('vi');
        this.translate.use('vi'); // Set your language here

        this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
            this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
        });
        this.config.set('ios', 'backButtonText', '');
    }

    openPage(page) {
        this.menuCtrl.close();
        if (page.component) {
            if (page.component == 'CategoriesPage' && page.id == 0) {
                this.app.getActiveNavs()[0].push(page.component);

            } else {
                this.app.getActiveNavs()[0].push(page.component, { page: page });
            }
        } else {
            let phonetext = page['title'].split(':');
            if ((phonetext[1])) {
                let number = phonetext[1].trim();
                number = number.split('.').join('');
                number = number.split(' ').join('');
                this.callNumber.callNumber(number, true)
                    .then(res => console.log('Launched dialer!', res))
                    .catch(err => console.log('Error launching dialer', err));
            }
        }

    }

    fixBackButton() {
        this.platform.registerBackButtonAction(() => {
            // Catches the active view
            const nav = this.app.getActiveNavs()[0];
            const activeView = nav.getActive();
            // Checks if can go back before show up the alert
            if (activeView.name === this.rootPage) {
                if (nav.canGoBack()) {
                    nav.pop();
                } else {
                    this.confirmExit();
                }
            } else if (nav.canGoBack()) {
                nav.pop();

            } else {
                if (activeView.name !== 'ShopHomePage') {
                    nav.setRoot('ShopHomePage');
                } else {
                    this.confirmExit();
                }

            }
        });

    }

    confirmExit() {
        const alert = this.alertCtrl.create({
            title: 'Thoát ứng dụng',
            message: 'Bạn có muốn thoát ứng dụng?',
            buttons: [{
                text: 'Hủy',
                role: 'cancel',
                handler: () => {
                    //this.nav.setRoot(this.rootPage);
                }
            }, {
                text: 'Ok',
                handler: () => {
                    this.platform.exitApp();
                }
            }]
        });
        alert.present();
    }

    logout() {
        this.authService.logout();
        this.showAlert('Bạn đã đăng xuất thành công.');
        this.menuCtrl.close();
    }

    showAlert(msg: string) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }

    navigate(page) {
        this.menuCtrl.close();
        this.app.getActiveNavs()[0].setRoot(page);
    }

    processDeeplink(params: any) {
        if (params.$args && params.$args.page) {
            this.events.publish('deeplink', params.$args);
        }
    }

    /**
     * Hide filter
     */
    hideFilters() {
        this.menuCtrl.close('product_filter');
    }

    /**
     * Reset filter
     */
    // reset_filter() {
    //     this.filterBar.map(
    //         (item) => {
    //             item.list.map((att: FilterAttribute) => {
    //                 att.checked = false;
    //             })
    //         }
    //     );
    //     this.hideFilters();
    // }
    /**
     * Set checked value
     * @param att Filter item
     * @author Le Van Son
     */
    // toggleCheckbox(att: FilterAttribute) {
    //     att.checked = !att.checked;
    // }
    /**
     * Apply product fileter
     * @author Le Van Son
     */
    // apply_filter() {
    //     this.logger.log('Filter', '');
    //     this.events.publish('product:filter_selected', this.getSelectedFilter());
    //     this.hideFilters();
    // }
    /**
     * Return selected filter
     * @returns FilterSelected[]
     */
    // getSelectedFilter(): FilterSelected[] {
    //     let selected: FilterSelected[] = [];
    //     this.filterBar.map(
    //         (item) => {
    //             let itemSelected = new FilterSelected({ id: item['id'], checked: [] });
    //             item.list.map((att: FilterAttribute) => {
    //                 if (att.checked) {
    //                     itemSelected.checked.push(att.id);
    //                 }
    //             })
    //             selected.push(itemSelected);
    //         }
    //     );
    //     return selected;
    // }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts